/**
 * @param {string|number} ssn
 * @returns {{month: number, year: number, day: number}|undefined}
 */
function getBirthdateFromSsn (ssn) {
  if (!ssn) return

  // Trim value
  let val = ssn
    .toString()
    .trim()

  // Get century sign
  const centurySign = val.indexOf('+') >= 0 ? '+' : '-'

  // Remove all characters except numbers
  val = val.replace(/[^0-9.]/g, '')

  if (val.length !== 10) return

  const currentDate = new Date()
  let year = val.substring(0, 2)
  const month = val.substring(2, 4)
  const day = val.substring(4, 6)
  const birthDate = new Date(parseInt(year, 10), (month - 1), parseInt(day, 10))
  const timeDiff = Math.abs(currentDate.getTime() - birthDate.getTime())
  const ageDate = new Date(timeDiff)
  const age = Math.abs(ageDate.getUTCFullYear() - 1970)

  const currentYear = currentDate.getFullYear()
  const currentCentury = parseInt(currentYear.toString().substr(0, 2))
  let century = currentCentury - 1

  if (age >= 100 && centurySign === '-') { century = currentCentury }
  year = `${century}${year}`

  return {
    day: parseInt(day, 10),
    month: parseInt(month, 10),
    year: parseInt(year, 10)
  }
}

module.exports = { getBirthdateFromSsn }
